'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('./../../external/@babel/runtime/helpers/esm/extends.js');
var defineProperty = require('./../../external/@babel/runtime/helpers/esm/defineProperty.js');
var objectWithoutProperties = require('./../../external/@babel/runtime/helpers/esm/objectWithoutProperties.js');
var React = require('react');
var index = require('./../../external/classnames/index.js');
var index$1 = require('../../utilities/GatsbyLink/index.js');
var arrow_right_inline = require('../../assets/svg/arrow_right.inline.svg.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);

var _excluded = ["action", "active", "arrow", "block", "children", "circle", "className", "color", "disabled", "download", "gradient", "innerRef", "link", "outline", "role", "size", "social", "tag", "target", "type"];

/**
 * A customizable button component.
 *
 * @param {Object} props - The props object for the component.
 * @param {boolean} [props.action] - Whether the button is an action button.
 * @param {boolean} [props.active] - Whether the button is currently active.
 * @param {boolean} [props.arrow] - Whether to show an arrow icon on the button.
 * @param {boolean} [props.block] - Whether the button should take up the full width of its container.
 * @param {boolean} [props.circle] - Whether the button should be circular.
 * @param {React.ReactNode} props.children - The content of the button.
 * @param {string} [props.className] - Additional CSS classes to apply to the button.
 * @param {'black'|'secondary'|'white'} [props.color] - The color of the button. One of: black | secondary | white
 * @param {boolean} [props.disabled] - Whether the button is disabled.
 * @param {string} [props.download] - The filename to download, if the button is a link.
 * @param {string} [props.gradient] - The gradient to apply to the button.
 * @param {string} [props.href] - The URL to link to, if the button is a link.
 * @param {string} [props.id] - The ID of the button.
 * @param {Function | string} [props.innerRef] - A ref to the button.
 * @param {boolean} [props.link] - Whether the button is a link.
 * @param {React.MouseEventHandler} [props.onClick] - A function to run when the button is clicked.
 * @param {boolean} [props.outline] - Whether the button is outlined.
 * @param {string} [props.role] - The role of the button, if the button is a link.
 * @param {string} [props.size] - The size of the button.
 * @param {string} [props.social] - The social network to apply a specific className.
 * @param {React.ElementType} [props.tag] - The HTML tag to use for the button.
 * @param {'_self'|'_blank'|'_parent'|'_top'} [props.target] - The target of the button, if the button is a link.
 * @param {'button'|'submit'|'reset'} [props.type] - The type of the button.
 *
 * @example
 * //Defaults arrow=true children='TEXT' color='secondary' tag='button'
 * <Button color='black' onClick={() => console.log('clicked')}>
 *  Click Me
 * </Button>
 *
 * @returns {JSX.Element} The rendered button component.
 */

var Button = function Button(props) {
  var _classNames;
  var action = props.action,
    active = props.active,
    _props$arrow = props.arrow,
    arrow = _props$arrow === void 0 ? true : _props$arrow,
    block = props.block,
    children = props.children,
    circle = props.circle,
    className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'secondary' : _props$color,
    disabled = props.disabled,
    download = props.download,
    gradient = props.gradient,
    innerRef = props.innerRef;
    props.link;
    var outline = props.outline,
    role = props.role,
    size = props.size,
    social = props.social,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'button' : _props$tag,
    target = props.target,
    type = props.type,
    attributes = objectWithoutProperties.default(props, _excluded);
  if (!children) {
    throw new Error('Button component requires children.');
  }
  var classes = index.default(color && "btn-".concat(color), color && outline && "btn-outline-".concat(color, " lanl-btn-outline"), 'btn lanl-btn', gradient && "".concat(gradient, "-gradient"), (_classNames = {
    active: active,
    'btn-circle': circle,
    'btn-block': block,
    'btn-action': action
  }, defineProperty.default(_classNames, "btn-".concat(social), social), defineProperty.default(_classNames, "btn-".concat(size), size), defineProperty.default(_classNames, "disabled", disabled), _classNames), className);
  if (attributes && attributes.href && Tag === 'button') {
    Tag = index$1.default;
  }
  var renderArrow = function renderArrow() {
    return arrow && /*#__PURE__*/React__default.default.createElement(arrow_right_inline.default, {
      className: "btn-arrow"
    });
  };
  return /*#__PURE__*/React__default.default.createElement(Tag, _extends.default({
    "data-testid": "lanl-button",
    type: Tag === 'button' && !type ? 'button' : type,
    target: target,
    role: Tag === 'a' && !role ? 'button' : role,
    className: classes,
    ref: innerRef
  }, attributes, {
    download: download,
    disabled: disabled
  }), children, renderArrow());
};

exports.Button = Button;
exports.default = Button;
//# sourceMappingURL=Button.js.map
